
const cols = [
  {
    name: {
      en: 'Decorative',
      es: 'Decorativo',
      fr: 'Décoratif',
      it: 'Decorativo'
    },
    pathname: {
      en: '/collection/decorative',
      es: '/collection/decorativo',
      fr: '/collection/décoratif',
      it: '/collection/decorativo'
    },
    src: '/images/twocols-decorativo.png'
  },
  {
    name: {
      en: 'Architectural',
      es: 'Arquitectural',
      fr: 'Architectural',
      it: 'Architettonico'
    },
    pathname: {
      en: '/collection/architectural',
      es: '/collection/arquitectural',
      fr: '/collection/architectural',
      it: '/collection/architettonico'
    },
    src: '/images/twocols-architecture.png'
  },
  {
    name: {
      en: 'Outdoor',
      es: 'Outdoor',
      fr: 'Outdoor',
      it: 'Outdoor'
    },
    pathname: {
      en: '/collection/outdoor',
      es: '/collection/outdoor',
      fr: '/collection/outdoor',
      it: '/collection/outdoor'
    },
    src: '/images/outdoor.png'
  }
]

export const getRelatedCols = (querySlug) => {
  if (!querySlug) return null
  const slug = typeof querySlug === 'string' ? querySlug : querySlug[1]

  switch (slug) {
    case 'outdoor':
      return [cols[0], cols[1]]
    case 'architectural':
    case 'arquitectural':
    case 'architettonico':
      return [cols[0], cols[2]]
    default:
      return [cols[1], cols[2]]
  }
}


export type TypeParsedUrlSearchParams = Record<string, string[]>

export const getActiveFilters = (filters, searchParams: TypeParsedUrlSearchParams, lang) => {
  // console.log('filters to get new TypeActiveFilter by server or browser back/forward actions', filters)
  if (!searchParams) return {}
  const arr = {}
  Object.entries(searchParams).map(([key, values]) => {
    // TODO PASS LANG PARAM
    const keyFilter = filters.find((filter) => filter.slug[lang] === key)
    if(!keyFilter) return
    arr[key] = {}

    for(const value of values) {
      if(keyFilter.values[value]) {
        arr[key][value] = true
      }
    }

  })
  // console.log('getActiveFilters arr', arr)
  return arr
}
